import { loginAPI, getUserInfoAPI } from "@/api/userApi";
import { getToken, setToken, removeToken, getuserInfo, setuserInfo, removeuserInfo } from "@/utils/utils";

function fetchAndSaveUser(ctx) {
  return getUserInfoAPI().then((res) => {
    ctx.commit("clearUserInfo");
    ctx.commit("setuserInfo", JSON.stringify(res.data));
  });
}

export default {
  namespaced: true,
  state: () => {
    const cached = getuserInfo();
    return {
      token: getToken() || "",
      userInfo: cached ? JSON.parse(cached) : "",
      passWord: "",
    };
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      setToken(token);
    },
    clearToken(state) {
      state.token = "";
      removeToken();
    },
    setuserInfo(state, userInfo) {
      state.userInfo = JSON.parse(userInfo);
      setuserInfo(userInfo);
    },
    clearUserInfo(state) {
      state.userInfo = "";
      removeuserInfo();
    },
  },
  actions: {
    async doLogin(ctx, JSONDATA) {
      const res = await loginAPI(JSONDATA);
      if (Number(res.code) === 200) {
        ctx.commit("setToken", res.data.token);
        await fetchAndSaveUser(ctx);
      }
      return res;
    },
    async scanCodeLogin(ctx, token) {
      ctx.commit("setToken", token);
      await fetchAndSaveUser(ctx);
    },
    clearLogin(ctx) {
      ctx.commit("clearUserInfo");
      ctx.commit("clearToken");
    },
  },
};
